<template>
  <v-dialog v-if="dialog" v-model="dialog" max-width="500" persistent>
    <v-card>
      <v-toolbar color="primary" dark style="position: sticky;
                          top: 0;
                          z-index: 1000;">

        <v-toolbar-title>Novo Envelope de Assinaturas</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark icon :disabled="isLoading" @click="closeFunc()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-dialog v-model="isLoading" max-width="400" persistent>
            <v-list class="py-5" color="primary" elevation="12" rounded>
              <v-list-item class="d-flex justify-space-between">
                <div>
                  <span style="color: white; font-size: large;">Criando Envelope de Assinatura</span>
                </div>
                <div>
                  <v-progress-circular color="#1A237E" indeterminate size="32" width="2"></v-progress-circular>
                </div>
              </v-list-item>
            </v-list>
          </v-dialog>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-form ref="envelopeForm" v-model="isValidForm">
          <v-row cols="12" class="mt-4">
              <v-text-field :disabled="isLoading" label="Nome do Envelope *" v-model="envelope.name" outlined :rules="ruleRequired"/>
          </v-row>
          <v-row class="negative-20-margin-top" cols="12">
              <v-text-field :disabled="isLoading" v-model="envelope.default_subject" label="Assunto Padrão do e-mail de Notificação" outlined/>
          </v-row>
          <v-row class="negative-20-margin-top" cols="12">
            <v-textarea :disabled="isLoading" v-model="envelope.default_message" no-resize rows="3" label="Mensagem Padrão de Notificação" outlined/>
          </v-row>
          <v-row class="negative-20-margin-top" cols="12">
            <v-col cols="7" style="padding: 0;">
              <v-text-field
                  v-model="envelope.deadline_at"
                  @input="onInputDate"
                  @keypress="onKeyPressDate"
                  maxLength="16"
                  :disabled="isLoading"
                  label="Prazo Final"
                  outlined/>
            </v-col>
            <v-col cols="5" style="padding: 0 0 0 5px;">
                <v-select
                    outlined
                    :disabled="isLoading"
                    v-model="envelope.remind_interval"
                    label="Intervalo de Lembrete"
                    :items="intervalReminder"
                />
            </v-col>
          </v-row>
          <v-row cols="12" class="negative-30-margin-top">
            <v-checkbox :disabled="isLoading" v-model="envelope.auto_close" label="Finalizar Fluxo Automaticamente"></v-checkbox>
          </v-row>
          <v-row cols="12" class="negative-30-margin-top">
            <v-checkbox :disabled="isLoading" v-model="envelope.block_after_refusal" label="Pausar Fluxo Após Recusa de Assinatura"></v-checkbox>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="isLoading" :loading="isLoading" dark text color="primary" @click="createEnvelope()">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import NewEnvelopeModalScript from "./NewEnvelopeModalScript";

export default NewEnvelopeModalScript;
</script>

<style scoped>
.negative-30-margin-top {
  margin-top: -30px;
}

.negative-20-margin-top {
  margin-top: -20px;
}
</style>